// extracted by mini-css-extract-plugin
export default {"list":"ListCustomBoardContainer_list__YKuEH"};